export const getStyled = (theme, isAdmin) => ({
  ticketsWrapper: {
    position: 'relative',
    display: 'flex',
    height: '100vh',
    flexDirection: 'column',
    overflow: 'hidden',
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    backgroundColor: theme.palette.mode === 'light' ? '#ffff' : '#192734',
  },

  ticketsWrapperContacts: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    height: '100%',
    flexDirection: 'column',
    overflow: 'hidden',
    width: '100%',
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    backgroundColor: theme.palette.mode === 'light' ? '#ffff' : '#192734',
    color: theme.palette.mode === 'light' ? '#192734' : '#fff',
    borderColor: theme.palette.mode === 'light' ? '#192734' : '#fff',
  },

  tabsHeader: {
    minWidth: 'auto',
    width: 'auto',
    borderRadius: 8,
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    backgroundColor: theme.mode === 'light' ? '#ffff' : '#192734',
  },

  settingsIcon: {
    alignSelf: 'center',
    marginLeft: 'auto',
    padding: theme.spacing(1),
  },

  tab: {
    '& .MuiTab-root': {
      color: theme.custom.colors.text,
    },
    '& .Mui-selected': {
      color: theme.custom.colors.text,
    },
    '& .MuiTabs-indicator': {
      backgroundColor: `${theme.custom.colors.text} !important`,
      height: '3px',
    },

    '@media (maxWidth: 1200px)': {
      fontSize: '0.9rem',
      padding: theme.spacing(0.4, 0.8),
      marginRight: theme.spacing(0.4),
      marginLeft: theme.spacing(0.4),
    },

    '@media (maxWidth: 900px)': {
      fontSize: '0.8rem',
      padding: theme.spacing(0.3, 0.6),
      marginRight: theme.spacing(0.3),
      marginLeft: theme.spacing(0.3),
    },

    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
      boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
    },

    '& .MuiTabs-flexContainer': {
      justifyContent: 'center',
    },
  },
  tabPanelItem: {
    minWidth: '33%',
    fontSize: 11,
    marginLeft: 0,
    justifyContent: 'center',
    textAlign: 'center',
    fontFamily: 'Tahoma, sans-serif',

    '@media (maxWidth:1450px)': {
      transform: 'scale(0.85)',
    },
  },
  tabIndicator: {
    height: 6,
    bottom: 0,
    borderRadius: '0 0 8px 8px',
    backgroundColor: theme.palette.mode === 'light' ? '#ffff' : '#192734',
  },
  ticketOptionsBox: {
    backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#192734',
    borderRadius: 8,
    borderColor: theme.palette.mode === 'light' ? '#192734' : '#fff',
    borderWidth: '1px',
    borderStyle: 'solid',
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    padding: theme.spacing(1),
  },
  boxOptions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 2,
    justifyContent: 'flex-start',
    width: '100%',
  },
  serachInputWrapper: {
    flex: 1,
    height: 40,
    background: theme.custom.colors.total,
    display: 'flex',
    borderRadius: 40,
    padding: 4,
    borderColor: theme.palette.mode === 'light' ? '#192734' : '#fff',
    color: '#fff',
    borderWidth: '1px',
    borderStyle: 'solid',
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  searchIcon: {
    color: theme.custom.colors.text,
    marginLeft: 6,
    marginRight: 6,
    alignSelf: 'center',
  },
  searchInput: {
    flex: 1,
    border: 'none',
    color: theme.palette.mode === 'light' ? '#192734' : '#fff',
    borderRadius: 30,
  },
  customBadge: {
    '& .MuiBadge-badge': {
      backgroundColor: theme.custom.colors.cancelButton,
      color: '#fff',
      padding: '2px 6px',
      borderRadius: '50%',
      fontSize: '10px',
      transform: 'translate(110%, -50%)',
    },

    '@media (min-resolution: 1.2dppx)': {
      '& .MuiBadge-badge': {
        transform: 'translate(70%, -45%) scale(0.8)',
      },
    },
  },
  groupBadge: {
    position: 'absolute',
    right: '-40%',
    backgroundColor: '#f44336',
    color: '#fff',
    padding: '2px 6px',
    borderRadius: '50%',
    fontSize: '10px',
    lineHeight: '12px',
    display: 'flex',
    justifyContent: 'center',
    width: 'fit-content',

    '@media (maxWidth: 1450px)': {
      right: '5%',
    },
  },
  customTab: {
    overflow: 'visible',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },

  customBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: '-5%',
  },
  customText: {
    marginLeft: 2,
    fontSize: 12,
    fontWeight: 800,
    fontFamily: `Tahoma, sans-serif`,
    color: theme.palette.mode === 'light' ? '#192734' : '#fff',
  },
  customIcon: {
    fontSize: 20,
    color: theme.palette.mode === 'light' ? '#192734' : '#fff',
  },
  customNotifyIcon: {
    padding: 0,
    minWidth: 0,
    borderRadius: '50%',
    width: '25px',
    transform: 'translate(-30%, 10%)',
  },
  show: {
    display: 'block',
  },
  hide: {
    display: 'none !important',
  },
  closeAllFab: {
    backgroundColor: 'red',
    marginBottom: '4px',
    '&:hover': {
      backgroundColor: 'darkred',
    },
  },
  speedDial: {
    position: 'absolute',
    bottom: theme.spacing(1),
    right: theme.spacing(1),
    '& .MuiFabRoot': {
      width: '40px',
      height: '40px',
      marginTop: '4px',
    },
    '& .MuiFabLabel': {
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },

  yesButton: {
    backgroundColor: '#FFF',
    color: theme.custom.colors.confirmButton,
    padding: '4px 4px',
    fontSize: '1em',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    marginRight: theme.spacing(1),
    '&:hover': {
      backgroundColor: 'darkGreen',
      color: '#FFF',
    },
    borderRadius: 30,
  },
  noButton: {
    backgroundColor: '#FFF',
    color: theme.custom.colors.cancelButton,
    padding: '4px 4px',
    fontSize: '1em',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    '&:hover': {
      backgroundColor: 'darkRed',
      color: '#FFF',
    },
    borderRadius: 30,
  },
  filterIcon: {
    alignSelf: 'center',
    cursor: 'pointer',
    backgroundColor: 'transparent',
    boxShadow: 'none',
    border: 'none',
    borderRadius: '50%',
    justifyContent: 'flex-end',
    alignItems: 'center',
    color: theme.custom.colors.text,
  },
  button: {
    flex: '1 0 16%',
    minWidth: 0,
    height: 64,
    border: '2px solid',
    borderColor: theme.custom.colors.text,
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(0.5),
    textTransform: 'none',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    textAlign: 'center',
    color: theme.custom.colors.text,
    opacity: '0.5',

    '@media (maxWidth: 1150px)': {
      flex: `1 0 ${isAdmin === 'user' ? '22%' : '30%'}`,
      height: 49,
    },
  },

  buttonText: {
    fontSize: 9,
    transform: 'scaleY(1.1)',
    lineHeight: 0.9,
    textAlign: 'center',
    wordBreak: 'break-word',
    whiteSpace: 'normal',
    color: theme.custom.colors.text,
  },
  icon: {
    fontSize: '28px !important',
    color: theme.palette.mode === 'light' ? '#192734' : '#fff',
  },
  buttonOpen: {
    '& $icon': {
      color: theme.palette.mode === 'light' ? '#192734' : '#fff',
    },
  },

  dialog: {
    '& .MuiDialogPaper': {
      width: '400px',
      maxWidth: '400px',
    },
  },
  dialogTitle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  colorDialog: {
    backgroundColor: theme.palette.mode === 'light' ? '#ffff' : '#192734',
    color: theme.custom.colors.text,
    borderTopColor: theme.custom.colors.hover,
    borderBottomColor: theme.custom.colors.hover,
  },
});
